const Delimiter = () => <div className="!w-[100%] h-[1.5px] bg-default-100" />;

export default Delimiter;
